// ToastProvider.js
import React, { createContext, useState, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToast.css'; // Import custom CSS if you have

export const ToastContext = createContext();

const ToastProvider = ({ children }) => {
  const [position] = useState('top-right');
  const [autoClose] = useState(2000);
  const [hideProgressBar] = useState(false);
  const [closeOnClick] = useState(true);
  const [pauseOnHover] = useState(true);
  const [draggable] = useState(true);
  const [theme] = useState('colored');

  const showToast = useCallback((message, type = 'info') => {
    switch (type) {
      case 'success':
        toast.success(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme,
        });
        break;
      case 'error':
        toast.error(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme,
        });
        break;
      case 'warning':
        toast.warning(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme,
        });
        break;
      case 'info':
        toast.info(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme,
        });
        break;
      default:
        toast(message, {
          position,
          autoClose,
          hideProgressBar,
          closeOnClick,
          pauseOnHover,
          draggable,
          theme,
        });
    }
  }, [position, autoClose, hideProgressBar, closeOnClick, pauseOnHover, draggable, theme]);

  const value = {
    showToast,
    success: (message) => showToast(message, 'success'),
    error: (message) => showToast(message, 'error'),
    warning: (message) => showToast(message, 'warning'),
    info: (message) => showToast(message, 'info'),
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer
        position={position}
        autoClose={autoClose}
        hideProgressBar={hideProgressBar}
        newestOnTop={false}
        closeOnClick={closeOnClick}
        rtl={false}
        pauseOnFocusLoss
        draggable={draggable}
        pauseOnHover={pauseOnHover}
        theme={theme}
      />
    </ToastContext.Provider>
  );
};

export default ToastProvider;